import { CoreButton } from '@ingenico/react-ui/core-button';

import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import AddToHome from '@mui/icons-material/AddToHomeScreen';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { LogicalDeviceActionsProps } from './logicalDeviceActions.model';
import styles from './logicalDeviceActions.module.scss';

export function ScreenShareButton({
  isScreenShareAvailable,
  isScreenShareDisabled,
  isScreenShareSessionInProgress,
  onClickScreenShare,
}: LogicalDeviceActionsProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE, ALL_LNGS_NAMESPACES.COMMON]);

  return (
    <div className={styles.container}>
      {isScreenShareAvailable && (
        <CoreButton
          className={styles.screenShareButton}
          disabled={!!isScreenShareDisabled}
          onClick={isScreenShareDisabled ? undefined : onClickScreenShare}
          startIcon={<AddToHome />}
          variant="outlined"
        >
          {isScreenShareSessionInProgress
            ? t('button.openScreenShareTab', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })
            : t('button.screenShare', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
        </CoreButton>
      )}
    </div>
  );
}
